import { ChangeDetectionStrategy, Component, inject, isDevMode, Renderer2, DOCUMENT } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { IconComponent } from './icon/icon.component';

import { IsActiveMatchOptions, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ChristmasLightsComponent } from '../christmas-lights/christmas-lights.component';
import { environment } from '../environments/environment';
import { EventService } from './event.service';
import { EasterEggsComponent } from '../easter-eggs/easter-eggs.component';

@Component({
  selector: 'app-root',
  imports: [IconComponent, RouterLink, RouterOutlet, RouterLinkActive, ChristmasLightsComponent, EasterEggsComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly eventService = inject(EventService);
  protected readonly isDevMode = isDevMode;

  protected readonly activeOptions: { exact: boolean } | IsActiveMatchOptions = {
    paths: 'exact',
    matrixParams: 'ignored',
    fragment: 'ignored',
    queryParams: 'ignored',
  };

  constructor() {
    if (isPlatformServer(this.platformId)) {
      for (const url of environment.preconnect) {
        const linkElement = this.renderer.createElement('link') as HTMLLinkElement;
        this.renderer.setAttribute(linkElement, 'rel', 'preconnect');
        this.renderer.setAttribute(linkElement, 'href', url);
        this.renderer.appendChild(this.document.head, linkElement);
      }
    }
  }
}
